import { useState } from "react";
import { Render } from "../../../../../../../../homepage/Render";
import "./StoreDescription.scss";

export const StoreDescription = (props) => {
  const { packageData } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const description = packageData?.description || "";
  const truncatedDescription =
    description.length > 220
      ? description.substring(0, 220) + "..."
      : description;

  return (
    <Render if={packageData?.description}>
      <div className="description-inner-wrapper">
        <div className="description-content-and-btn-wrapper">
          <h3>Description</h3>
          <div className="description-content-wrapper">
            <div className="description-content">
              <div className="description-heading">
                {isExpanded ? description : truncatedDescription}
                {description.length > 220 && (
                  <button
                    className="view-more-btn"
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    {isExpanded ? "View Less" : "View More"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Render>
  );
};
